import { CacheProvider } from '@emotion/react';
import { es } from 'date-fns/locale';
import Head from 'next/head';
import Router from 'next/router';
import nProgress from 'nprogress';
import PropTypes from 'prop-types';
import { Toaster } from 'react-hot-toast';
import '@mui/lab';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import '../i18n';
import { createEmotionCache } from '../utils/create-emotion-cache';

Router.events.on('routeChangeStart', nProgress.start);
Router.events.on('routeChangeError', nProgress.done);
Router.events.on('routeChangeComplete', nProgress.done);

const clientSideEmotionCache = createEmotionCache();

const App = function App(props) {
  const { Component, emotionCache = clientSideEmotionCache, pageProps } = props;
  const getLayout = Component.getLayout ?? ((page) => page);

  return (
    <CacheProvider value={emotionCache}>
      <Head>
        <title>CIGES v3</title>
        <meta name="viewport" content="initial-scale=1, width=device-width" />
      </Head>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
        <CssBaseline />
        <Toaster position="top-center" />
        {getLayout(<Component {...pageProps} />)}
      </LocalizationProvider>
    </CacheProvider>
  );
};

App.propTypes = {
  Component: PropTypes.any.isRequired,
  emotionCache: PropTypes.object,
  pageProps: PropTypes.any.isRequired,
};

App.defaultProps = {
  emotionCache: clientSideEmotionCache,
};

export default App;
